import { createSelector } from "reselect";

export const ReplaceRGB = (text:string) => {
    if( typeof text === 'string') {
        let color_Sets = 0;
          let class_id = parseInt( (Math.random()*1000) as any ) ;
          text = text.replace(/}/g, () => { return ";}</style>" });
          text = text.replace(/{/g, () => { color_Sets ++; return `<span class="color_${color_Sets}_${class_id}"><style>.color_${color_Sets}_${class_id}{color: #` } );
          return `<span>${text}</span>`;
    }
    console.log(text);
    return text;
}
const rgbSelect = (text:string) => text;
export const rgbSelector = createSelector(
    rgbSelect,
    (text:string) =>  {  
        if( typeof text === 'string') {
            let color_Sets = 0; 
              let class_id = parseInt( (Math.random()*1000) as any ) ;
              text = text.replace(/}/g, () => { return ";}</style>" });
              text = text.replace(/{/g, () => { color_Sets ++; return `<span class="color_${color_Sets}_${class_id}"><style>.color_${color_Sets}_${class_id}{color: #` } );
              return `<span>${text}</span>`;
        }
        return text;
    }
  );
  
export const numberFormat = (num: number, replaceIntEnd = true) =>  {
    if (typeof num !== "number") num = Number(num);
    let n = num.toFixed(2);
    if (replaceIntEnd) n = n.replace('.00', '');
    return n.replace(/.+?(?=\D|$)/, function (f) {
        return f.replace(/(\d)(?=(?:\d\d\d)+$)/g, "$1 ");
    });
}

export const digitFormat = (number: string | number) => {
    return ('0' + number).slice(-2);
}
export const moneyFormat = (number: string | number) => {
    return ('0' + number).slice(-9);
}